import React from 'react'

const Plain = props => <div {...props} />

export default Plain
